module.exports = __webpack_public_path__ + "images/express-icon-760ec24d647abdad64097204dbde37fe.svg";